import React from "react";
import companyLogo from '../../assets/images/logo.png';
import "./css/Payment.css";



const PaymentFail = () => {

    const toICO = () => {
        window.location.href = "/"
    }

    return (
        <>
            <div className="payment-wrapper d-flex align-items-center min-vh-100">
                <div className="container text-center fluid">
                    <img src={companyLogo} alt="logo" className="img-fluid" />
                    <h4 className="payment-title-failed"><b>PAYMENT FAILED</b></h4>
                    <div className="progress">
                        <ul>
                            <li>
                                <i class="fas fa-times align-items-center justify-content-center failed"></i>
                                <p>PAYMENT UNSUCCESSFUL</p>
                            </li>
                            <li>
                                <i className="fas fa-circle align-items-center justify-content-center"></i>
                                <p>CHARRY TOKENS SENT</p>
                            </li>
                            <li>
                                <i className="fas fa-circle align-items-center justify-content-center"></i>
                                <p>TRANSACTION DONE</p>
                            </li>
                        </ul>
                    </div>
                    <button onClick={toICO} className="me-btn">Back To ICO</button>
                    <button className="me-btn">Official Website</button>
                </div>
            </div>
        </>
    )

}

export default PaymentFail;